<div class="mx-auto px-2 animate-fade-in">
    <div class="mb-8">
        <div class="flex flex-row gap-3 items-baseline">
          <h2 class="text-3xl font-extrabold text-gray-900 tracking-tight">Property Requests</h2>
          <div class="flex items-center justify-between flex-wrap gap-2 px-1">
            <div class="text-sm text-gray-500"> (
              <span class="font-semibold text-gray-800">{{ proRequests().length }}</span> clients &nbsp;·&nbsp;
              <span class="font-semibold text-gray-800">{{ getTotalRequests() }}</span> total requests
              )
            </div>
          </div>
        </div>
        <p class="text-gray-500 mt-2">Review property listings and assign the best-fit advisor for the client.</p>
    </div>

    <div class="mb-4 p-5 bg-white rounded-2xl border-1 border-gray-200 flex flex-col sm:flex-row gap-4 items-center transition-all duration-300">
      <div class="relative flex-grow w-full sm:w-auto">
        <input
          type="text"
          (input)="onTableSearch($event)"
          placeholder="Search by name, email or phone..."
          class="w-full py-2 pl-12 pr-4 border-2 border-gray-200 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
        />

        <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 h-6 w-6 text-indigo-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>

      </div>
    </div>
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <table class="w-full text-left border-collapse min-w-[1000px] md:min-w-full">
        <thead class="bg-gray-50 border-b border-gray-200">
          <tr>
            <th class="px-6 py-4 text-[11px] font-bold text-gray-500 uppercase tracking-widest">Client</th>
            <th class="px-6 py-4 text-[11px] font-bold text-gray-500 uppercase tracking-widest">Email</th>
            <th class="px-6 py-4 text-[11px] font-bold text-gray-500 uppercase tracking-widest">Contact</th>
            <th class="px-6 py-4 text-[11px] font-bold text-gray-500 uppercase tracking-widest">Requests</th>
            <th class="px-6 py-4 text-[11px] font-bold text-gray-500 uppercase tracking-widest text-right">Action</th>
          </tr>
        </thead>

        <tbody>

          @for (group of paginatedRequests(); track group.user.userId) {

            <tr class="bg-white hover:bg-gray-50 transition-all shadow-sm rounded-xl h-[72px]">

              <!-- CLIENT -->
              <td class="px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-sm font-bold">
                    {{ group.user.name.trim().charAt(0).toUpperCase() }}
                    {{ group.user.name.trim().split(' ')[1]?.charAt(0).toUpperCase() ?? '' }}
                  </div>

                  <div>
                    <p class="text-sm font-semibold text-gray-900 leading-5">
                      {{ group.user.name }}
                    </p>
                    <p class="text-xs text-gray-400">Client</p>
                  </div>
                </div>
              </td>

              <!-- EMAIL -->
              <td class="px-6 py-4">
                <div class="flex items-center gap-2 text-sm text-gray-700">
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                  <span class="truncate max-w-[180px]">
                    {{ group.user.email }}
                  </span>
                </div>
              </td>

              <!-- CONTACT -->
              <td class="px-6 py-4">
                <div class="flex items-center gap-2 text-sm text-gray-700">
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                  </svg>
                  {{ group.user.phone }}
                </div>
              </td>


              <!-- REQUESTS -->
              <td class="px-6 py-4">
                <span
                  (click)="openRequestModal(group); $event.stopPropagation()"
                  class="cursor-pointer inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700 hover:bg-indigo-200 transition">
                  {{ group.requests.length }} {{ group.requests.length === 1 ? 'request' : 'requests' }}
                </span>
              </td>

              <!-- ACTION -->
              <td class="px-6 py-4 text-right">
              @if(!group.assignedAdvisor){
                <button 
                  (click)="assignAdvisor(group); $event.stopPropagation()"
                  class="inline-flex items-center px-3 py-1.5 bg-white border border-indigo-200 text-indigo-600 text-xs font-bold cursor-pointer rounded-lg hover:bg-indigo-600 hover:text-white transition-all active:scale-95">
                  Assign Advisor
                </button>
              }@else{
                <div class="flex flex-col justify-end">
                  {{group.assignedAdvisor._id ? 'Advisor Assigned':''}}
                  <i><small class="text-gray-500">Assigned to : {{ group.assignedAdvisor?.name }}</small></i>
                </div>
              }

              </td>

            </tr>

          }

        </tbody>
      </table>
    </div>
    <div class="flex items-center justify-between mt-6 px-4 py-4 bg-white border border-gray-200 rounded-xl shadow-sm">
      <!-- LEFT -->
      <p class="text-sm text-gray-500 font-semibold">
        Showing 
        <span class="font-semibold text-gray-800">
          {{ (currentPage() - 1) * pageSize() + 1 }}
        </span>
        -
        <span class="font-semibold text-gray-800">
          {{ getRangeEnd() }}
        </span>
        of 
        <span class="font-semibold text-gray-800">
          {{ filteredRequests().length }}
        </span>
      </p>

      <!-- RIGHT -->
      <div class="flex items-center gap-2">

        <!-- Prev -->
        <button
          (click)="goToPage(currentPage() - 1)"
          class="px-4 py-2 text-sm font-bold rounded-lg border border-gray-200 bg-white hover:bg-indigo-50 hover:text-indigo-600 disabled:opacity-40 disabled:cursor-not-allowed"
          [disabled]="currentPage() === 1">
          Prev
        </button>

        <!-- Page numbers -->
        @for (page of pages(); track $index; let i = $index) {
          <button
            (click)="goToPage(i + 1)"
            class="w-9 h-9 text-sm font-bold rounded-lg border transition-all"
            [class.bg-indigo-600]="currentPage() === i + 1"
            [class.text-white]="currentPage() === i + 1"
            [class.text-gray-600]="currentPage() !== i + 1"
            [class.hover:bg-gray-100]="currentPage() !== i + 1">
            {{ i + 1 }}
          </button>
        }

        <!-- Next -->
        <button
          (click)="goToPage(currentPage() + 1)"
          class="px-4 py-2 text-sm font-bold rounded-lg border border-gray-200 bg-white hover:bg-indigo-50 hover:text-indigo-600 disabled:opacity-40 disabled:cursor-not-allowed"
          [disabled]="currentPage() === totalPages()">
          Next
        </button>

      </div>
    </div>
</div>



<!-- Assing modla -->

<div *ngIf="isAssignAdvisor()" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-md">
    
    <div class="bg-white w-full max-w-xl rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden animate-zoom-in">
        
        <div class="p-8 border-b border-gray-50 flex justify-between items-center">
            <div>
                <h2 class="text-2xl font-black text-gray-900 tracking-tight">Assign Advisor</h2>
                <p class="text-gray-500 text-sm">Link an advisor to  <strong>"{{formatPropertyNames(selectedPropReq())}}"</strong> </p>
            </div>
            <button (click)="closeModal()" class="p-2 bg-gray-50 rounded-full text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
        </div>

        <div class="p-8 space-y-6">
            <div class="relative group">
                <input type="text" (input)="onSearch($event)"
                       placeholder="Search advisors by name or expertise..." 
                       class="w-full pl-12 pr-4 py-4 bg-gray-50 border-2 border-transparent focus:border-indigo-500 focus:bg-white rounded-2xl outline-none transition-all"
                >
                <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-300 group-focus-within:text-indigo-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>

            <div class="space-y-3 max-h-64 overflow-y-auto pr-2">
              @for (advisor of advisorList(); track advisor._id) {
                <div 
                  (click)="selectAdvisor(advisor._id)"
                  [class]="'flex items-center justify-between p-4 rounded-2xl border-2 transition-all cursor-pointer group ' + 
                           (selectedAdvisorId() === advisor._id ? 'border-indigo-500 bg-indigo-50/30' : 'border-gray-50 hover:border-indigo-200')"
                >
                  <div class="flex items-center gap-4">
                    <img [src]="advisor?.advisorImg || 'user.jpeg'" [alt]="advisor.name" class="w-10 h-10 rounded-xl object-cover" />
                    <div>
                      <p class="text-sm font-bold text-gray-900">{{ advisor.name }}</p>
                      <p [class]="'text-[10px] font-bold uppercase tracking-widest ' + 
                                 (selectedAdvisorId() === advisor._id ? 'text-indigo-600' : 'text-gray-400')">
                        {{ advisor.specialization }}
                      </p>
                    </div>
                  </div>
            
                  <div [class]="'w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all ' + 
                               (selectedAdvisorId() === advisor._id ? 'bg-indigo-600 border-indigo-600' : 'border-gray-200 group-hover:border-indigo-400')">
                    
                    @if (selectedAdvisorId() === advisor._id) {
                      <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                      </svg>
                    }
                  </div>
                </div>
              }
            </div>
        </div>

        <div class="p-8 bg-gray-50 flex gap-4">
            <button (click)="closeModal()" class="flex-1 py-4 font-bold text-gray-500 hover:text-gray-700 transition-colors">Dismiss</button>
            <button (click)="confirmAdvisor()"
            [disabled]="isConfirmDisabled()" class="flex-1 py-4 bg-indigo-600 text-white font-extrabold rounded-2xl shadow-sm shadow-indigo-100 hover:bg-indigo-700 transition-all active:scale-95 disabled:bg-gray-300 disabled:cursor-not-allowed
            enabled:bg-indigo-600 enabled:hover:bg-indigo-700 enabled:shadow-lg enabled:shadow-indigo-200">Confirm Assignment</button>
        </div>
    </div>
</div>


<!-- PROPERTY REQUEST MODAL -->
<div *ngIf="isRequestModalOpen()" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/50 backdrop-blur-sm">

  <div class="bg-white w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden animate-zoom-in">

    <!-- HEADER -->
    <div class="px-8 pt-7 pb-5 border-b border-gray-100 flex justify-between items-start">
      <div>
        <h2 class="text-2xl font-extrabold text-gray-900 tracking-tight">
          Requested Properties
        </h2>
        <p class="text-sm text-gray-500 mt-1">
          By: {{ selectedUserName() }}
        </p>
      </div>

      <button 
        (click)="closeRequestModal()" 
        class="w-9 h-9 flex items-center justify-center rounded-full bg-gray-50 hover:bg-red-50 text-gray-400 hover:text-red-500 transition-all">
        ✕
      </button>
    </div>

    <!-- BODY -->
    <div class="px-8 py-6 max-h-[460px] overflow-y-auto space-y-4">

      @for (req of selectedUserRequests(); track req._id) {

        <div class="group flex items-center gap-4 p-4 rounded-2xl border border-gray-100 bg-white hover:shadow-md hover:border-gray-200 transition-all duration-200">

          <!-- IMAGE -->
          <div class="w-16 h-16 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0">
            <img 
              [src]="req.property.imageURL?.[0]" 
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              onerror="this.style.opacity='0.3'">
          </div>

          <!-- INFO -->
          <div class="flex-1 min-w-0">
            <p class="text-sm font-bold text-gray-900 truncate">
              {{ req.property.name }}
            </p>

            <div class="flex items-center gap-2 mt-1">
              <span class="px-2 py-0.5 rounded text-[11px] font-semibold bg-blue-50 text-blue-600">
                {{ req.property.propertyType }}
              </span>

              <span class="text-[11px] text-gray-400">
                • {{ req.createdAt | date:'dd MMM yyyy' }}
              </span>
            </div>
          </div>

          <!-- PRICE -->
          <div class="text-right flex-shrink-0">
            <p class="text-sm font-extrabold text-emerald-600 whitespace-nowrap">
              {{ formatPriceDisplay(req.property.price) }}
            </p>
          </div>

        </div>

      }

    </div>

  </div>
</div>